import { baseApi } from './baseApi';
import type { User } from '../../types/api';

interface LoginRequest {
  username: string;
  password: string;
  rememberMe?: boolean;
}

interface LoginResponse {
  user: User;
  token: string;
  refreshToken: string;
  expiresAt: string;
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Login endpoint
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/admin/login',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: (response: any) => {
        // Transform backend response to match frontend expectations
        // Backend returns: { access_token, token_type, expires_in }
        // Frontend expects: { user, token, refreshToken, expiresAt }

        // Decode JWT to get user info
        const tokenParts = response.access_token.split('.');
        const payload = JSON.parse(atob(tokenParts[1]));

        // Calculate expiresAt from expires_in
        const expiresAt = new Date(Date.now() + (response.expires_in * 1000)).toISOString();

        return {
          user: {
            id: payload.id || '1',
            username: payload.sub,
            email: payload.email || '',
            full_name: payload.full_name || '',
            role: payload.role || 'admin',
            is_active: true,
            is_ldap_user: payload.is_ldap_user || false,
            last_login: new Date().toISOString(),
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          },
          token: response.access_token,
          refreshToken: response.access_token,
          expiresAt: expiresAt
        };
      },
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useLoginMutation,
} = authApi;
